import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data/content";

const LINKS = [
  { label: "Services", href: "/#services" },
  { label: "About", href: "/about" },
  { label: "Save A Website", href: "/save-a-website" },
  { label: "Monthly Marketing", href: "/monthly-marketing" },
  { label: "Pricing", href: "/#pricing" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-ink/70 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-20">
        <a href="/#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="w-2.5 h-2.5 bg-accent rotate-45 group-hover:rotate-0 transition-transform duration-300" />
          <span className="font-head font-extrabold tracking-tighter text-lg">
            EmergentSac<span className="text-accent">.com</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="mono-label text-text-2 hover:text-accent transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center gap-1.5 bg-accent text-ink font-head font-bold text-sm px-5 py-2.5 hover:bg-white transition-colors"
        >
          Get a Quote <ArrowUpRight className="w-4 h-4" />
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-ink/95 backdrop-blur-xl border-b border-line"
          >
            <div className="container-x py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="mono-label text-text-2 hover:text-accent"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="/#contact"
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center gap-1.5 bg-accent text-ink font-head font-bold text-sm px-5 py-3"
              >
                Get a Quote <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
